export default "__VITE_ASSET__DZeqA6fA__"